import HttpService from '../baseHttp'


// 新品预选
// 列表、查看、编辑/添加、删除、取消、审核通过/审核驳回（单个/批量）、提交审核（单个/批量）、添加备注，复制单据
export const HttpGetPrimaryList = (data = {}, config) => HttpService.get('/api/v2/productDevelopmentPreselection/findByPage', { params: data });

export const HttpGetPrimaryOne = (data = {}, config) => HttpService.get('/api/v2/productDevelopmentPreselection/getById', { params: data });

export const HttpSavePrimaryOne = (data = {}, config) => HttpService.post('/api/v2/productDevelopmentPreselection/save', data, { headers: { "Content-Type": "application/json" }, params: { contextId: global.SYSID } });

export const HttpDeletePrimaryOne = (data = {}, config) => HttpService.get('/api/v2/productDevelopmentPreselection/deleted', { params: data });

export const HttpCancelPrimaryOne = (data = {}, config) => HttpService.get('/api/v2/productDevelopmentPreselection/cancel', { params: data });

export const HttpCheckPrimary = (data = {}, config) => HttpService.get('/api/v2/productDevelopmentPreselection/check', { params: data });

export const HttpSubmitPrimary = (data = {}, config) => HttpService.get('/api/v2/productDevelopmentPreselection/submit', { params: data });

export const HttpRemarkPrimary = (data = {}, config) => HttpService.get('/api/v2/productDevelopmentPreselection/remark', { params: data });

export const HttpCopyPrimaryOne = (data = {}, config) => HttpService.get('/api/v2/productDevelopmentPreselection/copy', { params: data });

// 新品推荐
// 列表、查看、编辑/添加、删除、取消、审核通过/审核驳回（单个/批量）、提交审核（单个/批量）、添加备注
export const HttpGetRecommendList = (data = {}, config) => HttpService.get('/api/v2/productDevelopmentRecommend/findByPage', { params: data });

export const HttpGetRecommendOne = (data = {}, config) => HttpService.get('/api/v2/productDevelopmentRecommend/getById', { params: data });

export const HttpSaveRecommendOne = (data = {}, config) => HttpService.post('/api/v2/productDevelopmentRecommend/save', data, { headers: { "Content-Type": "application/json" }, params: { contextId: global.SYSID } });

export const HttpDeleteRecommendOne = (data = {}, config) => HttpService.get('/api/v2/productDevelopmentRecommend/deleted', { params: data });

export const HttpCancelRecommendOne = (data = {}, config) => HttpService.get('/api/v2/productDevelopmentRecommend/cancel', { params: data });

export const HttpCheckRecommend = (data = {}, config) => HttpService.get('/api/v2/productDevelopmentRecommend/check', { params: data });

export const HttpSubmitRecommend = (data = {}, config) => HttpService.get('/api/v2/productDevelopmentRecommend/submit', { params: data });

export const HttpRemarkRecommend = (data = {}, config) => HttpService.get('/api/v2/productDevelopmentRecommend/remark', { params: data });

// 附件的新增、删除
export const HttpUploadPrimaryAttach = (data = {}, config) => HttpService.get('/api/v2/productDevelopmentPreselection/updateAttach', { params: data });

export const HttpUploadRecommendAttach = (data = {}, config) => HttpService.get('/api/v2/productDevelopmentRecommend/updateAttach', { params: data });

// 推荐列表-》关联预选产品列表
export const HttpRecommendAndProdeve = (data = {}, config) => HttpService.get('/api/v2/productDevelopmentPreselection/getByRecommendId', { params: data });



// 以下都是预选产品里面需要的接口
// 预选产品获取预编码
export const HttpPrimaryPreCoding = (data = {}, config) => HttpService.get('/api/v2/productDevelopmentPreselection/getPreCoding', { params: data });

// 报价列表，单条查看报价，编辑/保存单条报价
export const HttpGetOfferList = (data = {}, config) => HttpService.get('/api/v2/productDevelopmentOffer/findByPage', { params: data });

export const HttpGetOfferOne = (data = {}, config) => HttpService.get('/api/v2/productDevelopmentOffer/getById', { params: data });

export const HttpSaveOfferOne = (data = {}, config) => HttpService.post('/api/v2/productDevelopmentOffer/save', data, { headers: { "Content-Type": "application/json" }, params: { contextId: global.SYSID }, transformRequest:(data)=>{ return JSON.stringify(data)} });

// 报价确认，报价驳回，报价删除
export const HttpCheckOfferOne = (data = {}, config) => HttpService.get('/api/v2/productDevelopmentOffer/check', { params: data });

export const HttpCancelOfferOne = (data = {}, config) => HttpService.get('/api/v2/productDevelopmentOffer/cancel', { params: data });

export const HttpDeleteOfferOne = (data = {}, config) => HttpService.get('/api/v2/productDevelopmentOffer/deleted', { params: data });

// 提交打样需求，打样信息录入
export const HttpSubmitProofing = (data = {}, config) => HttpService.post('/api/v2/productDevelopmentOffer/proofing', data, { headers: { "Content-Type": "application/json" }, params: { contextId: global.SYSID } }) 

export const HttpCheckProofing = (data = {}, config) => HttpService.post('/api/v2/productDevelopmentOffer/checkProofing', data, { headers: { "Content-Type": "application/json" }, params: { contextId: global.SYSID } }) 


// 转为正式产品
export const HttpSaveProductDev = (data = {}, config) => HttpService.post('/api/v2/productDevelopmentRelated/save', data, { headers: { "Content-Type": "application/json" }, params: { contextId: global.SYSID } });

// 获取预选产品关联的正式产品信息
// 转为正式产品
export const HttpQueryErpsku = (data = {}, config) => HttpService.get('/api/v2/productDevelopmentRelated/findByPreselectionId', { params: data });
// 添加品类弹框
export const HttpUnCategory = (data = {}, config) => HttpService.get('/api/v2/productDevelopmentRecommend/categoryId', { params: data });

// 修改主图
export const HttpSavePic = (data = {}, config) => HttpService.get('/api/v2/productDevelopmentPreselection/savePic', { params: data });

// 上架查看信息
export const HttpStoreinNews = (data = {}, config) => HttpService.get('/api/v2/productDevelopmentShelves/findByPage', { params: data });


// 推荐看板
export const HttpproductDevelopmentRecommend = (data = {}, config) => HttpService.get('/api/v2/productDevelopmentRecommend/kanBan/getValue', { params: data });
// 预选看板
export const HttpproductDevelopmentPreselection = (data = {}, config) => HttpService.get('/api/v2/productDevelopmentPreselection/kanBan/getValue', { params: data });


// 判断文件名称传值是否正确
// export const HttpgetFileName = (data = {}, config) => HttpService.get('/api/v2/productDevelopmentOffer/checkFileName', { params: data });
export const HttpgetFileName  = (data = {}, config) => HttpService.post('/api/v2/productDevelopmentOffer/checkFileName', data, { headers: { "Content-Type": "application/json" }, params: { contextId: global.SYSID } });

// 批量导出文件
export const HttpUpdateAttach  = (data = {}, config) => HttpService.post('/api/v2/productDevelopmentOffer/updateAttach', data, { headers: { "Content-Type": "application/json" }, params: { contextId: global.SYSID } });

export const HttpUpdateAttachOne  = (data = {}, config) => HttpService.post('/api/v2/productDevelopmentOffer/addAttach', data, { headers: { "Content-Type": "application/json" }, params: { contextId: global.SYSID } });



// 删除报告
export const HttpDeleteBaogao = (data = {}, config) => HttpService.get('/api/v2/productDevelopmentOffer/delAttach', { params: data });


